import { useFormikContext } from "formik"

import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { useDateTime } from "../../../../../../modules/localization/useDateTime"
import { SelectedPriceListItem } from "../../../createOrderTypes"
import { useCreateOrderDialogType } from "../../../hooks/useCreateOrderDialogType"
import { DynamicConfigKey, MeetingServiceTabValues } from "../../form/formTypes"
import {
    DeadlineMessageDisplayType,
    DeadlineMessageQuery,
    fetchDeadlineMessage,
    selectDeadlineMessage,
} from "../../shop/delivery/deliveryApi"
import { buildDeadlineMessageParams } from "../../shop/delivery/helpers"

import { MessageCard } from "./MessageCard"

type DeadlineMessageCardProps = Readonly<{
    priceList: SelectedPriceListItem
}>

export function DeadlineMessageCard({ priceList }: DeadlineMessageCardProps) {
    const { values } = useFormikContext<MeetingServiceTabValues>()
    const { isSpecialOrder } = useCreateOrderDialogType()
    const dateTimeFactory = useDateTime()

    const deliveries = values[DynamicConfigKey.MULTIPLE_DELIVERIES]
    const deadlineParams = buildDeadlineMessageParams({ priceList, deliveries, dateTimeFactory })

    const { data: deadlineMessage } = useApiQuery(fetchDeadlineMessage, {
        queryName: DeadlineMessageQuery.DELIVERY_DEADLINE_MESSAGE,
        dependencies: deadlineParams,
        select: selectDeadlineMessage,
        enabled: !!deadlineParams.deliveryTime && !isSpecialOrder,
        // otherwise the card blinks on every added product
        keepPreviousData: true,
    })

    if (
        isSpecialOrder ||
        // keepPreviousData keeps the old message after the date is cleared
        !deadlineParams.deliveryTime ||
        !deadlineMessage ||
        deadlineMessage.isConfirmed ||
        !deadlineMessage.message?.displayRule ||
        deadlineMessage.displayType !== DeadlineMessageDisplayType.CARD
    ) {
        return null
    }

    return <MessageCard text={deadlineMessage.message.displayRule} severity="warning" />
}
